import React, { useContext, useEffect, useState } from 'react'
import { FormattedDate, FormattedMessage } from "react-intl";
import InventoryCenterBadges from "../../InventoryCenterBadges";

import { withStyles} from "@mui/styles";
import showStyle from "assets/jss/views/picking/order/showStyle";

import {Authorizations, hasAuthorization} from "utils/authorizations";
import { ShipmentStatus } from "utils/ShipmentStatus";
import { ShippingMethods } from "utils/ShippingMethods";
import { checkIfAllAssigned, LineItemStatus } from "utils/LineItemStatus";
import { OrderContext } from "contexts/OrderContext";
import { isDateBeforeWmsActivation } from "utils/WMSActivation";
import CustomCheckbox from "components/checkbox/CustomCheckbox";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import {lighterBlack} from "assets/jss/main";

function ShipmentTitle({classes, incrementalNumber, shipment, lineItems, displayShipmentCheckbox, setDisplayShipmentCheckbox, isAddressExpanded, toggleAddress}) {

    const {
        shippedAt,
        shippingMethod,
        createdAt,
        status,
    } = shipment;

    const {
        handleChangeCheckboxGlobal,
        selectedShipment,
        authorizations,
        member,
        currentOrganization
    } = useContext(OrderContext);

    const statusIsToShip = status !== ShipmentStatus.SHIPPED;
    const someItemsToShip = lineItems.some((item) => {
        return item.status === LineItemStatus.TO_SHIP;
    });
    var allItemAreHandledByWMS = lineItems.every((item) => item['wmsReady'] === true) && !isDateBeforeWmsActivation(createdAt, currentOrganization);

    const isClickAndCollect = shippingMethod.type === ShippingMethods.CLICK_COLLECT;
    const isPickingManager = hasAuthorization(authorizations, Authorizations.PICKING_MANAGER);
    const isRetailer = hasAuthorization(authorizations, Authorizations.PICKING_RETAILER);
    const canClickAndCollect = hasAuthorization(authorizations, Authorizations.PICKING_RETAILER_C_C);
    const canDrive = hasAuthorization(authorizations, Authorizations.PICKING_RETAILER_DRIVE);
    const isClickAndCollectAndHaveAuthorization = isClickAndCollect && canClickAndCollect;
    const isAssigned = checkIfAllAssigned(lineItems, member);
    const canShip = isPickingManager || isAssigned || (isRetailer && canDrive) || isClickAndCollectAndHaveAuthorization;
    const shouldDisplayButton = someItemsToShip && statusIsToShip && canShip && !(currentOrganization?.wms && allItemAreHandledByWMS);

    useEffect(() => {
        setDisplayShipmentCheckbox(shouldDisplayButton);
    }, [shouldDisplayButton]);

    function formattedShippedAtDate(shipmentDate) {
        return (
            <>
                <FormattedDate
                    value={new Date(shipmentDate)}
                    year={"numeric"}
                    month={"numeric"}
                    day={"numeric"}
                />&nbsp;-&nbsp;
                <FormattedDate
                    value={new Date(shipmentDate)}
                    hour={"numeric"}
                    minute={"numeric"}
                />
            </>
        );
    }

    function displayShipmentTitle() {
        if (statusIsToShip) {
            return (<FormattedMessage id={'picking.order.shipments.header.preexpedition'} />);
        }
        return (<FormattedMessage id={'picking.order.shipments.header.expedition'} />);
    }

    /**
     * Add/remove all shipment's lineItems when
     * checking/unchecking the checkbox
     */
    function handleCheckbox(event) {
        handleChangeCheckboxGlobal(null);

        if (event.target.checked) {
            handleChangeCheckboxGlobal(shipment);
        }
    }

    /**
     * Check if the current shipment is selected
     */
    function isChecked() {
        return selectedShipment?.id === shipment.id;
    }

    function displayCheckbox() {
        if (!displayShipmentCheckbox) {
            return null;
        }

        return (
            <CustomCheckbox
                onChange={handleCheckbox}
                checked={isChecked()}
            />
        );
    }

    return (
        <>
            <div className={classes.shipmentTitleCell}>
                {displayCheckbox()} 
                <div className={classes.titleAndDate}>
                    <span className={statusIsToShip ? classes.title : classes.titleLight}>
                        <b>
                            {displayShipmentTitle()} {incrementalNumber}
                            &nbsp;-&nbsp;
                            {shippingMethod.name ?? <FormattedMessage id={`picking.order.shippingMethod.${shippingMethod.shippingMethodShopName}`} defaultMessage={shippingMethod.name} />}
                        </b>
                        {currentOrganization?.inventories.length > 1 && (
                            <InventoryCenterBadges shipments={[shipment]} />
                        )}

                    </span>
                    <span className={classes.date}>
                        {formattedShippedAtDate(shippedAt || createdAt)}
                        { shipment.externalDeliveryNumber &&
                            <span>
                                &nbsp;-&nbsp;
                                <FormattedMessage id={`picking.order.shipments.header.externalDeliveryNumber`} />
                                {shipment.externalDeliveryNumber}
                            </span>
                        }
                        { shipment.relayPoint &&
                            <span>
                                <br/>
                                <FormattedMessage id={`picking.order.shipments.header.relayPoint`} />{shipment.relayPoint}
                                {shipment.shipmentAddress?.company &&
                                    <span> - {shipment.shipmentAddress?.company}</span>
                                }
                            </span>
                        }
                        <div 
                            onClick={toggleAddress}
                            style={{ 
                                marginTop: '8px',
                                cursor: 'pointer',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '4px',
                                color: lighterBlack,
                                fontWeight: 500
                            }}
                        >
                            <FormattedMessage id={`picking.order.shipments.header.shippingAddress`}/>
                            {isAddressExpanded ? <KeyboardArrowUpIcon fontSize="small" /> : <KeyboardArrowDownIcon fontSize="small" />}
                        </div>
                    </span>
                </div>
            </div>
        </>
    );
}

export default withStyles(showStyle)(ShipmentTitle);
